module.exports = __webpack_public_path__ + "img/sp3.6901f3fb.png";